import React, { useState, useEffect, MouseEvent, useRef } from 'react';
import { Divider, Stack, Popover, Popper, Typography, Skeleton, SxProps, Theme, Slide, IconButton, Dialog, DialogTitle, DialogContent } from '@mui/material';
import "@/app/style/racingInfo.scss";
import _ from 'lodash';
import { useMyContext } from '@/app/utils/MyContext';
import { LANGTYPE_EN, useLanguage } from '@/app/utils/LanguageContext';
import { setRacesDetailLoading, setRouting, theme, generateAdobeDataRaceNo, adobeData, isLastRaceRan, getSearchParams, getMeetingCountryAbbr} from '@/app/utils/Common';
import { useMediaQuery, Grid } from "@mui/material";
import { Meeting } from '@/app/utils/class/cms';
import { RaceNo } from '@/app/utils/class/common/base';
import NoInformation from '@/app/ui/Common/NoInformation';
import { dateFormat, formattedDate, toDate } from '@/app/utils/DayJS';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import CloseIcon from '@mui/icons-material/Close';
import { TransitionProps } from '@mui/material/transitions';
import { VideoWAData } from "@/app/ui/Common/VideoPlayer/player";
import { getTrackAnalysis, getSelectedMeetingBroadcast, getBroadcastConfig, getUpcomingHVSTMt} from '@/app/utils/request/requestList';
import VideoPlayerIcon2 from "@/app/ui/Common/SvgComponent/VideoPlayerIcon2";
import { ValidVideo, VideoSource } from "@/app/utils/class/common/video";
import { generateVideoSource, generateVideoUrl, validateVideo } from "@/app/utils/Video";
import VideoPlayer from "@/app/ui/Common/VideoPlayer/trackVideoIndex";
import RaceSelector2 from "@/app/ui/Common/RaceSelector2";
import Tips from '@/app/ui/Common/Tips';
import ReplayIcon from "@/app/ui/Common/SvgComponent/ReplayIcon";
import { useParams, usePathname } from 'next/navigation';
import { useLoading } from '@/app/utils/LoadingContext';
import CalendarSvgIcon from '@/app/ui/Common/SvgComponent/CalendarSvgIcon';
import CalendarPopper from '@/app/ui/UpcomingRaces/calendarPopper';
const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<unknown>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function a11yProps(index: number) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <div>{children}</div>
            )}
        </div>
    );
}

const generateRaceName = (defaultName: string, venueCode: string, raceName: string) => {
    return venueCode ? `(${venueCode}) ${raceName}` : defaultName
}

interface RacingInfoProps {
    type: string;
    meetings: IMeeting[];
    onTips1Dismiss?: () => void;
    showTips1?: any;
    setRacesDetailLoading: (loading: boolean) => void;
    handleSelectRace: (raceNo: number) => void;
    raceSelectorData?: any
}


const CanShowField = (props:any, type: string):boolean=>{
    const {broadcastConfig,item}=props;
    if (type === 'broadcastTime') return broadcastConfig?.enableBroadcastTime?.value&&item?.broadcastTime?.value!=''
    return broadcastConfig?.[`enable${type}`]?.value&&item?.[`${type.toLowerCase()}`]?.value!=''
  }
const CanShow=(props:any):boolean=>{
    const {broadcastConfig,item,idx}=props
    var canShow=false;
    if( broadcastConfig?.enableBroadcastTime?.value&&item?.broadcastTime?.value!=''
        || broadcastConfig?.enableLanguages?.value&&item?.channels?.value!=''
        || broadcastConfig?.enableChannels?.value&&item?.channels?.value!=''
        || broadcastConfig?.enableReserved1?.value&&item?.reserved1?.value!=''
        || broadcastConfig?.enableReserved2?.value&&item?.reserved2?.value!=''
        || broadcastConfig?.enableReserved3?.value&&item?.reserved3?.value!='') canShow=true
    return canShow
  }
  

const RacingInfo = (props: RacingInfoProps) => {
    const { isLoading, triggerLoading, completeLoading } = useLoading();
    const isMobile = useMediaQuery(theme.breakpoints.down("lg")) ?? false;
    const { state: lang } = useLanguage();
    const { t } = lang;
    const { state: myContextState, dispatch: myContextDispatch } = useMyContext();
    const [tabIdx, setTabIdx] = useState(0);
    const [meetings, setMeetings] = useState<Meeting[]>([]);
    const [races, setRaces] = useState<IRace[]>([]);
    const [qRaces, setQRaces] = useState<any>(null);
    const [meetingInfo, setMeetingInfo] = useState<any>(null);
    const isLoadingRaceInfo = globalConfig.OTHERS.ENABLE_LOADING_CONTEXT ? isLoading('page') : myContextState.isLoadingRaces;
    // const [isShowSelect, setIsShowSelect] = useState(false);
    // const [openSelectEvent, setOpenSelectEvent] = useState<any>(null);

    const [openRaceInfo, setOpenRaceInfo] = useState(true);
    const [openDialog, setOpenDialog] = useState(false);
    const [openPopperFG, setOpenPopperFG] = useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [isDownloadFormGuideTip, setIsDownloadFormGuideTip] = useState(false);
    const [trackAnalysisData, setTrackAnalysisData] = useState<any>(null);
    const [expertName, setExpertName] = useState<string>('');
    const [isShowVideoPlay, setIsShowVideoPlay] = useState(false);
    const [videoSources, setVideoSources] = useState([] as VideoSource[]);
    const [WAData, setWAData] = useState<VideoWAData | undefined>(undefined);
    const [isDimFormGuide, setisDimFormGuide] = useState(false);
    const [calendarAnchorEl, setCalendarAnchorEl] = useState<null | HTMLElement>(null);
    //const [selectedRaceNo, setSelectedRaceNo] = useState<number>(-1);

    const [broadcastRemarks, setBroadcastRemarks] = useState<any>(''); 
    const [broadcastContent, setBroadcastContent] = useState<any>([]); 
    const [broadcastConfig, setBroadcastConfig] = useState<any>({});
    const [trackVideoType, settrackVideoType] = useState("");
    const [isLoadingAnalysis, setIsLoadingAnalysis] = useState<boolean>();
    const { RaceDate: urlDate } = getSearchParams(new URLSearchParams(window.location.search));
    const paths = usePathname().split("/");
    useEffect(()=>{
        if (myContextState.isLoadingMeetings) return;
        if (props.meetings.length === 0) return;
        // get Upcoming ST/HV meeting
        if(props.meetings?.length) {
            const controller = new AbortController();
            const signal = controller.signal;
            
            const sim_Meeting = props.meetings?.filter((i:any) => i?.presite?.boolValue);
            const allPresite = sim_Meeting?.length > 0 && sim_Meeting?.length == props.meetings?.length;
            if (allPresite || !window.globalConfig.TwoASwitch) {
                const newMeetings = props.meetings?.map((mt)=> new Meeting(mt));
                setMeetings(newMeetings);
                return
            } 
            getUpcomingHVSTMt("",signal).then((res: any) => {
                const notReadyStatus = ["ENTRY", "DRAFT",'INITIAL', 'ENTRY_ABANDON'];
                // on same racedate
                const mtgs = res?.commonMeetings?.filter((mt:any) => !notReadyStatus.includes(mt?.status) 
                && mt?.date?.replaceAll("-", "") == urlDate)?.map((i:any) => {
                    return {
                        meetingVenueCode: {
                            value: i?.venueCode
                        },
                        races: [{
                            raceInfo : i?.races
                        }],
                        meetingDate: i?.date,
                        status: i?.status,
                    }
                }) || [];

                const newMeetings = [...props.meetings, ...mtgs]?.map((mt)=> new Meeting(mt));
                setMeetings(newMeetings);
            });
        } else {
            const newMeetings = props.meetings?.map((mt)=> new Meeting(mt));
            setMeetings(newMeetings);
        }
     

      }, [props.type, props.meetings, myContextState.isLoadingMeetings])
      
    // find matched meeting data
    useEffect(()=>{
        if (myContextState.isLoadingRaces || !myContextState.selectedMeeting) return;
        const selectedMeetingIdx = meetings?.findIndex((mt)=>mt.isMatchWithVenueCode(myContextState.selectedMeeting?.venueCodeForSearchParam()));
        setTabIdx(selectedMeetingIdx);
        setRaces(myContextState.selectedMeeting?.races || []); 
        //setSelectedRaceNo(myContextState?.selectedRaceNo.valueOf())
        console.log("RacingInfo myContextState-Races", myContextState,);
    }, [meetings, myContextState.selectedMeeting, myContextState.isLoadingRaces])

    useEffect(() => {
        const qidsMtg =  meetings?.find((x) => x.isMatchWithVenueCode(myContextState.selectedMeeting?.venueCodeForSearchParam()))?.RaceMeetingProfile;
        const qidsRace = qidsMtg?.races?.find((r: any) => r.no == myContextState?.selectedRaceNo.valueOf());

        const curCMSRace = races?.find((x) => new RaceNo(x?.displayName)?.valueOf() == myContextState?.selectedRaceNo.valueOf());
        console.log("RacingInfo qidsMtg", meetings,qidsMtg, qidsRace, curCMSRace, myContextState);

        const mtgInfo = {
            meetingName: myContextState.selectedMeeting?.racedayName,
            carnivalInfo: myContextState.selectedMeeting?.carnivalInfo,
            formatDate: formattedDate(toDate(curCMSRace?.raceDatetime?.value, dateFormat.cms.datetime), dateFormat.display.fulldatetime),
            going: myContextState?.selectedRaceNo.valueOf() == -1 ? '' : qidsRace?.[lang.langCode == "en-us" ? "go_en" : "go_ch"],
            racecourse: myContextState.selectedMeeting?.racecourseName,
            countryName: myContextState.selectedMeeting?.countryName,
            group: myContextState?.selectedRace?.group,
            raceDistance: myContextState?.selectedRace?.raceDistance,
            raceName: myContextState?.selectedRace?.raceName,
            worldPoolPath: myContextState?.selectedMeeting?.RaceImages?.targetItems?.[0]?.RaceimageURL?.src
        }
        setMeetingInfo(mtgInfo);
        setQRaces(qidsMtg?.races);
    }, [tabIdx, myContextState.selectedMeeting, myContextState?.selectedRace])

    //get FormGuides if need Dim
    useEffect(() => {
        const ifneedDim = !checkFormGuidesData();
        setisDimFormGuide(ifneedDim)
    }, [myContextState?.formGuides])

    //get Track analysis video thumbnail
    useEffect(() => {
        if (myContextState.isLoadingRaces) return;
        if (!myContextState.selectedMeeting?.displayName) {
            setRacesDetailLoading(props.setRacesDetailLoading)
            completeLoading('page');
            return
        }
        setIsLoadingAnalysis(true);
        getTrackAnalysis(lang.langCode, myContextState.season, myContextState.selectedMeeting?.displayName)
            .then(async (res: any) => {
                if (res?.item) {
                    const videoUrl = res?.item?.videoLink?.value ? generateVideoUrl(res?.item?.videoLink?.value) : undefined;
                    const videoValidation = await validateVideo(videoUrl);
                    const trackAnalysisData = { ...res?.item, videoUrl: videoUrl, videoValidation: videoValidation };
                    setTrackAnalysisData(trackAnalysisData);
                    const expertName = res?.item?.expertSelection?.value || '';
                    if (expertName !== '') {
                        setExpertName(expertName);
                    }
                    
                    if (myContextState.selectedRace?.trackMap?.src  &&
                        trackAnalysisData?.videoLink?.value && 
                        trackAnalysisData?.videoValidation?.hasVideo() ) {
                        settrackVideoType("imageWithVideo")

                    } else if (myContextState.selectedRace?.trackMap?.src ) {
                        settrackVideoType("onlyImage") 
                    } 
                } else {
                    if (myContextState.selectedRace?.trackMap?.src ) {
                        settrackVideoType("onlyImage") 
                    } 
                    setTrackAnalysisData(null);
                }

            })
            .catch((e: any) => {
                console.log(e);
            }).finally(() => {
                setRacesDetailLoading(props.setRacesDetailLoading);
                completeLoading('page');
                setIsLoadingAnalysis(false)
            });
    }, [myContextState.selectedMeeting, myContextState.isLoadingRaces]);

    useEffect(() => {
        if (myContextState.selectedRace?.trackMap?.src  &&
            trackAnalysisData?.videoLink?.value &&
            trackAnalysisData?.videoValidation?.hasVideo() ) {
            settrackVideoType("imageWithVideo")

        } else if (myContextState.selectedRace?.trackMap?.src) {
            settrackVideoType("onlyImage")
        }
    }, [myContextState.selectedRace])
    //get Broadcast
    useEffect(() => {
        if (myContextState.selectedMeetingDate?.getTime() === new Date(0)?.getTime()) return;
        getSelectedMeetingBroadcast(lang.langCode, myContextState.season, myContextState.selectedMeetingDate)
            .then((res: any) => { 
                const tempContent = res?.items?.content?.filter((i:any) => i?.broadcasts?.length > 0 && !!i?.title?.value )
                setBroadcastContent(tempContent);
                setBroadcastRemarks(res?.items?.remarks?.value);
            })
            .catch((e: any) => {
                console.log(e);
            });
    }, [myContextState.selectedMeetingDate]);

    useEffect(()=>{
        getBroadcastConfig(lang.langCode)
        .then((res: any) => {                  
            setBroadcastConfig(res?.config);                  
        })
        .catch((e: any) => {
            console.log(e);
        });
    }, [])


    const handleVideoClose = () => {
        setIsShowVideoPlay(false);
        setWAData(undefined);
        setVideoSources([])
    }

    const openVideoPlayer = (validVideo: ValidVideo, url: any, waContentTitle?: string) => {
        if (!validVideo.hasVideo()) return;
        setWAData({
            buttonName: "racing/simulcast_ClickVideo_CommonMenu",
            raceNo: generateAdobeDataRaceNo(myContextState.selectedMeetingDate, myContextState.selectedMeeting?.meetingVenueCode, myContextState.selectedRaceNo.valueOf()),
            contentTitle: waContentTitle,
        });
        setVideoSources(generateVideoSource(url.sd, url.hd));
        setIsShowVideoPlay(true);

        const curRace = myContextState.selectedMeeting?.RaceMeetingProfile?.races?.find((r: any) => r.no == myContextState?.selectedRaceNo.valueOf());
    }

    const onClickDownloadFormGuide = (e: any, isFormGuideBtn: boolean) => {
        setAnchorEl(e.currentTarget);
        setIsDownloadFormGuideTip(isFormGuideBtn);
        if (!isFormGuideBtn) {
            setOpenDialog(true); 
            adobeData(lang.langType === LANGTYPE_EN ? "en" : "zh-hk", "interaction", {
                pageId: "racing/simulcast",
                eventId: "racing/simulcast_Click_AnyPage_Menu-Broadcast",
                country: myContextState.selectedMeeting?.countryNameEn || '',
                raceNo: generateAdobeDataRaceNo(myContextState.selectedMeetingDate, myContextState.selectedMeeting?.meetingVenueCode, myContextState.selectedRaceNo.valueOf()),
            });
        }else {
            if(props?.type == "pc"){
                setOpenPopperFG(true);
            }else {
                setOpenDialog(true);  
            } 
        }
    }

    const handleTabOnClick = (url?: string, buttonName?: string, waRaceNo?: string) => {
        if (url && waRaceNo) {
            const meetingRaceNo = waRaceNo?.split("-")?.slice(1, 3) || [];
            let buttonName = "";
            switch (true) {
                case meetingRaceNo[0] == "NA" && meetingRaceNo[1] == "NA":
                    buttonName = "All";
                    break;
                case meetingRaceNo[1] == "NA":
                    buttonName = `${meetingRaceNo[0]}-All`;
                    break;
                default:
                    buttonName = meetingRaceNo.join("-");
                    break;
            }

            adobeData(lang.langType === "english" ? "en" : "zh-hk", "interaction", {
                pageId: "racing/simulcast",
                eventId: "racing/simulcast_Click_AnyPage_FormGuideShortcut",
                country: myContextState.selectedMeeting?.countryNameEn || '',
                buttonName: `racing/simulcast_Click_${buttonName}`,
                raceNo: generateAdobeDataRaceNo(myContextState.selectedMeetingDate, myContextState.selectedMeeting?.meetingVenueCode, myContextState.selectedRaceNo.valueOf()),
            });
        }
        //setIsShowSelect(false);
    }

    const checkFormGuidesData = () => {
        let show = false;
        for (let i = 0; i < myContextState?.formGuides?.length; i++) {
            const item = myContextState?.formGuides[i];
            if (item?.hasPdf) {
                show = true;
                break
            }
            const hasSubPdf = item?.nextLevel?.some((subItem) => subItem?.hasPdf)
            if (hasSubPdf) {
                show = true;
                break
            }
        }
        return show
    }

    const RenderDownloadFormGuide = (props?: any) => {
        return (
            <>
                <DialogContent className='dialogcontent'>
                    <div>
                        {
                            myContextState.formGuides?.map((item: FormGuideData, idx: number) => {
                                const hasSubPdf = item.nextLevel?.some((subItem) => subItem.hasPdf)
                                return ( (item.hasPdf || hasSubPdf) && 
                                    <div key={idx} className={`raceItem ${!item?.nextLevel || item?.nextLevel?.length == 0 ? 'all' : ''}`}>

                                        {item.hasPdf ? // (!item?.nextLevel || item?.nextLevel?.length == 0) ? 
                                            <p><a className='fullWidth' href={item.url} target='_blank' data-bool={item.hasPdf} onClick={(e) => handleTabOnClick(item.url, item.name, item.waRaceNo)}>{item.name}</a>
                                            </p> :
                                            <p className='venue'>{item?.name}</p>}
                                        <div>
                                            {
                                                item?.nextLevel?.map((subItem: FormGuideData, i: number) => (
                                                    subItem?.hasPdf &&
                                                    <p key={i}>
                                                        <a id={`${item.name}_${subItem.name}`}
                                                            href={subItem.url}
                                                            target='_blank'
                                                            data-bool={subItem.hasPdf}
                                                            onClick={(e) => handleTabOnClick(subItem.url, subItem.name, subItem.waRaceNo)}>{subItem.name} </a>
                                                    </p>
                                                ))
                                            }
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </DialogContent>
            </>
        )
    }

    const broadcastArrangementData = [
        {
            meetingName: "Newmarket Handicap Day",
            venueCode: "S1",
            items: [
                {
                    time: "10:05am",
                    name: "until end of the race",
                    leftContent: "TVB Ch82, i-Cable CH18, NOW TV NOW668 & Ch630, HKJC TV*, Racing Touch*",
                    rightContent: "Cantonese/English"
                },
                {
                    time: "10:05am",
                    name: "until end of the race",
                    leftContent: "TVB Ch82, i-Cable CH18, NOW TV NOW668 & Ch630, HKJC TV*, Racing Touch*",
                    rightContent: "Cantonese/English"
                },
                {
                    time: "10:05am",
                    name: "until end of the race",
                    leftContent: "TVB Ch82, i-Cable CH18, NOW TV NOW668 & Ch630, HKJC TV*, Racing Touch*",
                    rightContent: "Cantonese/English"
                }
            ]
        },
        {
            meetingName: "Newmarket Handicap Day",
            venueCode: "S2",
            items: [
                {
                    time: "10:05am",
                    name: "until end of the race",
                    leftContent: "TVB Ch82, i-Cable CH18, NOW TV NOW668 & Ch630, HKJC TV*, Racing Touch*",
                    rightContent: "Cantonese/English"
                },
                {
                    time: "10:05am",
                    name: "until end of the race",
                    leftContent: "TVB Ch82, i-Cable CH18, NOW TV NOW668 & Ch630, HKJC TV*, Racing Touch*",
                    rightContent: "Cantonese/English"
                },
                {
                    time: "10:05am",
                    name: "until end of the race",
                    leftContent: "TVB Ch82, i-Cable CH18, NOW TV NOW668 & Ch630, HKJC TV*, Racing Touch*",
                    rightContent: "Cantonese/English"
                }
            ]
        }
    ]

    const checkIfCanShow = () => {
        const canshow = broadcastContent?.filter((ctn:any) => ctn?.broadcasts?.filter((bcast:any) => CanShow({broadcastConfig, bcast}))?.length > 0 )?.length > 0
        console.log('【ifNeedDim】', canshow)
        return canshow
    }
    const RenderBroadcastArrangement = () => {
        return (
            <div className='broadcastArrangement'>
                {
                    //broadcastArrangementData && broadcastArrangementData?.map((baData: any, idx: number) => (
                    broadcastContent?.map((ctn:any, idx: number) =>  (
                        <div key={idx}>
                            <p className='header-tit'>{ctn?.title?.value}</p>
                            {
                                ctn?.broadcasts?.map((item: any, i: string) =>  (
                                    CanShow({broadcastConfig,item}) ? 
                                    <div className='content' key={i}>
                                        {
                                            props?.type == "pc" ? <>
                                                <Stack
                                                    direction="row"
                                                    spacing={'12px'}
                                                    sx={{
                                                        "div": {
                                                            flex: 1,
                                                            marginRight: '12px !important'
                                                        },
                                                        "div:last-child": {
                                                            marginRight: '0 !important'
                                                        },
                                                        "div:not(:first-child)": {
                                                            fontWeight: 400
                                                        }
                                                    }}
                                                >
                                                    {CanShowField({broadcastConfig,item}, 'broadcastTime') ? 
                                                    <div dangerouslySetInnerHTML={{ __html: item?.broadcastTime?.value }}></div> : null} 
                                                    <div>
                                                        {CanShowField({broadcastConfig,item}, 'Channels') ? <div dangerouslySetInnerHTML={{ __html: item?.channels?.value }}/> : null}
                                                        {CanShowField({broadcastConfig,item}, 'Reserved1') ? <div dangerouslySetInnerHTML={{ __html: item?.reserved1?.value }}/>: null}
                                                        {CanShowField({broadcastConfig,item}, 'Reserved2') ? <div dangerouslySetInnerHTML={{ __html: item?.reserved2?.value }}/>: null}
                                                        {CanShowField({broadcastConfig,item}, 'Reserved3') ? <div dangerouslySetInnerHTML={{ __html: item?.reserved3?.value }}/>: null}
                                                    </div> 
                                                    {CanShowField({broadcastConfig,item}, 'Languages') ? <div dangerouslySetInnerHTML={{ __html: item?.languages?.value }}/>: null}
                                                </Stack>
                                            </> : <>
                                                {CanShowField({broadcastConfig,item}, 'broadcastTime') ? 
                                                <p className='tit' dangerouslySetInnerHTML={{ __html: item?.broadcastTime?.value }}></p> : null} 
                                                {/* <p className='tit'>{item?.time} – {item?.name}</p> */}
                                                <Stack
                                                    direction="row"
                                                    divider={<Divider orientation="vertical" flexItem />}
                                                    spacing={"12px"}
                                                    className='items'
                                                >
                                                    <div>
                                                        {CanShowField({broadcastConfig,item}, 'Channels') ? <div dangerouslySetInnerHTML={{ __html: item?.channels?.value }}/> : null}
                                                        {CanShowField({broadcastConfig,item}, 'Reserved1') ? <div dangerouslySetInnerHTML={{ __html: item?.reserved1?.value }}/>: null}
                                                        {CanShowField({broadcastConfig,item}, 'Reserved2') ? <div dangerouslySetInnerHTML={{ __html: item?.reserved2?.value }}/>: null}
                                                        {CanShowField({broadcastConfig,item}, 'Reserved3') ? <div dangerouslySetInnerHTML={{ __html: item?.reserved3?.value }}/>: null}
                                                    </div> 
                                                    {CanShowField({broadcastConfig,item}, 'Languages') ? <div dangerouslySetInnerHTML={{ __html: item?.languages?.value }}/>: null}
                                                    {/* <div>{item?.leftContent}</div>
                                                    <div>{item?.rightContent}</div> */}
                                                </Stack>
                                            </>
                                        }

                                    </div>
                                    : null
                                ))
                            }
                        </div>
                    ))
                }
                {
                    broadcastRemarks && <div className='broadcastRemarks' dangerouslySetInnerHTML={{ __html: broadcastRemarks }} ></div>
                }
            </div>
        )
    } 
    const DialogMobile = () => {
        return (
            <Dialog
                open={props?.type == "mobile" && openDialog}
                keepMounted
                fullWidth
                TransitionComponent={Transition}
                className={props?.type == "pc" ? 'dialogPC' : ''}
                sx={{
                    '& .MuiModal-backdrop': {
                        zIndex: 0,
                        position: 'absolute'
                    },
                    '& .MuiDialog-container': {
                        alignItems: 'flex-end',
                        ' .MuiPaper-root': {
                            zIndex: 1
                        }
                    },
                    '& .MuiPaper-root': {
                        maxWidth: 'unset',
                        maxHeight: '94%',
                        width: '100%',
                        margin: 0,
                        overflowY: 'hidden',
                        borderRadius: '12px 12px 0 0',

                    },
                }}
                onClose={() => {setOpenDialog(false) }}
            >
                <DialogTitle className='dialogTit' id="customized-dialog-title">
                    {isDownloadFormGuideTip ? t('formGuide') : t('broadcast_arrangement')}
                </DialogTitle >
                <IconButton
                    className='dialogClose'
                    aria-label="close"
                    onClick={() => { setOpenDialog(false) }}
                >
                    <CloseIcon />
                </IconButton>
                {isDownloadFormGuideTip ? RenderDownloadFormGuide() : RenderBroadcastArrangement()}
            </Dialog>
        )
    }

    const PopoverPC = () => {
        return (
            <Popover
                className='popoverPC'
                id={openDialog ? "simple-popover" : undefined}
                open={props?.type == "pc" && openDialog}
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 32,
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                sx={{
                    "& .MuiPaper-root": {
                        width: isDownloadFormGuideTip ? '328px' : '683px',
                        maxHeight: '368px',
                        overflow: 'unset',
                        boxShadow: "0px 3px 10px 0px #0000004D"

                    }
                }}
                disableScrollLock
                onClose={() => { setOpenDialog(false); setAnchorEl(null) }}
            >
                <div className='popoverContent'>
                    <p className='tipUp'></p>
                    {isDownloadFormGuideTip ? RenderDownloadFormGuide() : RenderBroadcastArrangement()}
                </div>

            </Popover>
        )
    }

    const PopoverFormGuidePC = () => {
        return (
            <Popper 
                className='popoverPC' 
                open={props?.type == "pc" && openPopperFG}
                anchorEl={anchorEl}
                placement={"bottom-end"}  
                sx={{
                    "&.MuiPopper-root": {
                        width: '328px',
                        maxHeight: '368px',
                        overflow: 'unset',
                        boxShadow: "0px 3px 10px 0px #0000004D",
                        background: "#FFFFFF",
                        borderRadius: "4px",
                        zIndex: "999"
                        //top: "2px !important"

                    }
                }} 
            >
                <div className='popoverContent'>
                    <p className='tipUp'></p>
                    {RenderDownloadFormGuide()}
                </div> 
            </Popper >
        )
    } 

    const RenderBottomBtn = () => {
        return (
            <div className='botomBtn'>
                {
                    props?.type == "pc" ? 
                        <div id='formGuide' className={isDimFormGuide ? "btn_disabled" : ''}  
                        onMouseEnter={(e: any) => {isDimFormGuide ? null : onClickDownloadFormGuide(e, true)}}
                        onMouseLeave={(e: any) => {isDimFormGuide ? null : setOpenPopperFG(false); setAnchorEl(null) }}
                        >
                            <img src={`${myContextState?.assetPrefix}/downloadFormGuide${isDimFormGuide ? '_disabled' : ''}.svg`} />
                            {t('formGuide')}  
                            {PopoverFormGuidePC()}
                        </div>
                    : 
                        <div id='formGuide' className={isDimFormGuide ? "btn_disabled" : ''} 
                        onClick={(e: any) => { isDimFormGuide ? null : onClickDownloadFormGuide(e, true) }} 
                        >
                            <img src={`${myContextState?.assetPrefix}/downloadFormGuide${isDimFormGuide ? '_disabled' : ''}.svg`} />
                            {t('formGuide')}  
                        </div> 
                } 

                <div className={!checkIfCanShow() ? "btn_disabled" : ''} onClick={(e: any) => { !checkIfCanShow() ? null : onClickDownloadFormGuide(e, false) }}>
                    <img src={`${myContextState?.assetPrefix}/broadcastArrangement${!checkIfCanShow() ? '_disabled' : ''}.svg`} />
                    <span dangerouslySetInnerHTML={{ __html: broadcastConfig?.title?.value }}></span> 
                </div>
            </div>
        )
    }
    const showTrackVideo = () => myContextState.selectedRace?.trackMap?.src && trackAnalysisData?.videoLink?.value && trackAnalysisData?.videoValidation?.hasVideo() && !isLoadingAnalysis;

    const isTrackImageOnly = () => !(trackAnalysisData?.videoLink?.value && trackAnalysisData?.videoValidation?.hasVideo()) && myContextState.selectedRace?.trackMap?.src && window.globalConfig.OneBSwitch && !isLoadingAnalysis;

    const raceSelectorData =
    {
        ["S2"]: { races: [1, 2, 3, 4, 5] },
        ["S3"]: { races: [1, 2, 3, 4, 5] },
        ["S4"]: { races: [1, 2, 3, 4, 5] },
        [myContextState?.selectedMeetingVenueCode]: { races: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16] },
        ["S6"]: { races: [1, 2, 3, 4, 5] }
    }

    const handleSelectRace = (raceNo: number, venueCode: string) => {
        //if (tabIdx === venueCode) return
        const venue = meetings?.find((x: any) => x.meetingVenueCode == venueCode)?.venueCodeForSearchParam()

        setRacesDetailLoading(props.setRacesDetailLoading, myContextState.menuTab.toString(), true);
        triggerLoading('race', myContextState.menuTab.toString());
        console.log('route 8')
        setRouting(undefined, { 'Racecourse': venueCode, 'RaceNo': raceNo.toString(), 'b_cid': '' }, myContextState);
      
        // adobeData(lang.langType === LANGTYPE_EN ? "en" : "zh-hk", "interaction", {
        //     pageId: "racing/simulcast",
        //     internalAd: "SPLDSP_racing/simulcast-Menu_Race",
        // });
        
        if (raceNo != -1 && raceNo !== myContextState.selectedRaceNo.valueOf()) {
            //setRacesDetailLoading(props.setRacesDetailLoading, myContextState.menuTab.toString(), true, true);
            // triggerLoading('race', myContextState.menuTab.toString());
            //setSelectedRaceNo(raceNo);
            //   myContextDispatch({
            //     type: "update",
            //     value: { selectedRaceNo: new RaceNo(raceNo) },
            //   });
        }

        // console.log("RacingInfo handleSelectRace", venueCode)
        // setTabIdx(venueCode);
        // setSelectedRaceNo(raceNo);
        // if (tabIdx == venueCode) {
        //     myContextDispatch({
        //         type: "update", value: {
        //             selectedRaceNo: new RaceNo(raceNo),
        //         }
        //     });
        // } else {
        //     myContextDispatch({
        //         type: "update", value: {
        //             selectedMeetingVenueCode: venueCode,
        //             isChangingMeeting: true,
        //             isLoadingRaces: true,
        //             selectedRaceNo: new RaceNo(raceNo),
        //         }
        //     });
        // }

    };

    const handleChangeIndex = (index: number, mtg: any) => {
        if (tabIdx === index) return 
        if (["ST", "HV"].includes(mtg?.meetingVenueCode)) {
            const isAllFinish = isLastRaceRan(mtg);
            const _linkPages = (isAllFinish ? window.globalConfig.LINKED_PAGES.JCRWLOCALRESULES :
            window.globalConfig.LINKED_PAGES.JCRWLOCALRACECARD) + "&b_cid=SPLDSP_racing/simulcast-Menu_Race";
            const linkPages = _linkPages?.replace("{lang}", lang.langCode)?.replace("{racedate}", mtg?.meetingDate?.replaceAll("-", "/"))
            window.open(linkPages);
            return 
        } 
        setTabIdx(index);
        setRacesDetailLoading(props.setRacesDetailLoading, myContextState.menuTab.toString(), true);    
        triggerLoading('meeting'); 
        setTrackAnalysisData(null);
        setIsLoadingAnalysis(true);
        console.log('route 8', index)
        setRouting(undefined, {'Racecourse': meetings?.[index]?.venueCodeForSearchParam(), 'RaceNo': '', 'b_cid': 'SPLDSP_racing/simulcast-Menu_Race'}, myContextState);
        myContextDispatch({
          type: "update", value: {
            selectedMeetingVenueCode: meetings?.[index]?.venueCodeForSearchParam(),
            isChangingMeeting: true,
            isLoadingRaces: true,
            selectedRaceNo: new RaceNo(0),
          }
        });
      };

    const handleChangeRaceIndex = (raceNo: RaceNo) => {
        if (myContextState.selectedRaceNo == raceNo) return;
        
        setRacesDetailLoading(props.setRacesDetailLoading, myContextState.menuTab.toString(), true, true)
        triggerLoading('race', myContextState.menuTab.toString());
        setRouting(undefined, {'b_cid': 'SPLDSP_racing/simulcast-Menu_Race'}, myContextState);
        myContextDispatch({
          type: "update", value: {
            selectedRaceNo: raceNo,
          }
        });
      };

    const handleRaceInfo = () => {
        const text = `${meetingInfo?.raceName ? meetingInfo?.raceName + ', ' : '' }${meetingInfo?.group ? `${meetingInfo?.group}, ` : ''}${meetingInfo?.raceDistance ? `${meetingInfo?.raceDistance}, ` : ''}${meetingInfo?.formatDate}`
        //const text = `${props?.type == "pc" && ", "+meetingInfo?.formatDate}`
        return (myContextState.selectedRaceNo.valueOf()===-1) ? meetingInfo?.formatDate : text
    }

    const presite = myContextState.selectedMeeting?.presite;
     
    console.log("RacingInfo myContextState", tabIdx, meetings, races, myContextState)
    console.log("RacingInfo broadcast", broadcastContent, broadcastConfig)
    const isRaceCardPage = () => paths?.[paths?.length - 1].toLowerCase() == "race-card";
    
    useEffect(() => {
        document.addEventListener('click', handleOutSideclick);
        return () => {
            document.removeEventListener('click', handleOutSideclick);
        }
    }, [calendarAnchorEl]);

    const handleCalendarClose = () => {
        setCalendarAnchorEl(null);
    }

    const handleOutSideclick = (event: any) => {
        if (calendarAnchorEl && props.type == "pc") {
            const targetDiv = document.querySelector('.calendarPopper');
            const rect = targetDiv?.getBoundingClientRect() || {} as any;

            const isInside =
                event?.clientX >= rect?.left &&
                event?.clientX <= rect?.right &&
                event?.clientY >= rect?.top &&
                event?.clientY <= rect?.bottom;

            if (!isInside) {
                setCalendarAnchorEl(null)
            }
        }
    }

    const handleCalendarClink = (event: React.MouseEvent<HTMLElement>) => {
        setCalendarAnchorEl(calendarAnchorEl ? null : event.currentTarget);
        adobeData(lang.langType === LANGTYPE_EN ? "en" : "zh-hk", "interaction", {
            pageId: "racing/simulcast",
            eventId: "racing/simulcast_Click_AnyPage_UpcomingRace-Calendar",
            country: myContextState.selectedMeeting?.countryNameEn || '',
            raceNo: generateAdobeDataRaceNo(myContextState.selectedMeetingDate, myContextState.selectedMeeting?.meetingVenueCode, myContextState.selectedRaceNo.valueOf()),
        });
    };

    return myContextState.selectedMeeting ? (
        <>
            {
                !meetings?.some((x: any) => !x.presite) && myContextState?.upComRaceData?._None == true ? <></>:
                    !isLoadingRaceInfo && <Grid container xs={12} sx={{ ...(props.type === "pc" && { justifyContent: 'left' }) }} className={"raceInfoSelectBar" + (myContextState.selectedMeeting?.isPresite() ? " -presite" : "")}>
                        {!meetings?.some((x: any) => !x.presite) ? <span style={{paddingLeft: "12px"}}>{t("future_raceday")}</span> :
                            <RaceSelector2
                                type={props?.type}
                                handleSelectRace={handleChangeRaceIndex}
                                handleSelectMeeting={handleChangeIndex}

                                meetings={meetings}
                                races={races}
                                qidsRaces={qRaces}
                                tabIdx={tabIdx}
                            />
                        }
                        {
                            !(props.type == "mobile" && !myContextState.selectedMeeting?.isPresite()) && !myContextState?.upComRaceData?._None &&
                            <div className={"racingInfo-calendarBtn" + (myContextState.selectedMeeting?.isPresite() ? " -presite" : "")}>
                                <div onClick={(e) => { handleCalendarClink(e) }} style={{ marginRight: "12px" }}>
                                    <CalendarSvgIcon />
                                    {props.type == "pc" && <p>{formattedDate(toDate(myContextState?.selectedMeeting?.meetingDate?.value, dateFormat.cms.datetime), dateFormat.display.date)} - {getMeetingCountryAbbr(myContextState?.selectedMeeting?.meetingCountry || "", t)}</p>}
                                </div>
                                <CalendarPopper type={props.type} anchorEl={calendarAnchorEl} meetings={props?.meetings} handleCalendarClose={handleCalendarClose} />
                            </div>
                        }
                    </Grid>
            }

            <div className={`racingInfo ${props?.type == "pc" && "pc"} ${myContextState?.selectedMeeting?.isPresite() && myContextState?.upComRaceData?._None == true ? " noRaceInfoSelectBar" : ""}`}>
                <div>
                {/* <div className={`${presite ? 'b-info-presite' : ''}`}> */}
                    {
                        !isLoadingAnalysis && myContextState.selectedRace?.trackMap?.src && <div className='leftImg' onClick={() => {
                            if (showTrackVideo()) {
                                openVideoPlayer(trackAnalysisData?.videoValidation, trackAnalysisData?.videoUrl, trackAnalysisData?.videoTitle?.value)
                            } else {
                                setIsShowVideoPlay(true);
                            }
                            adobeData(lang.langType === LANGTYPE_EN ? "en" : "zh-hk", "interaction", {
                                pageId: "racing/simulcast",
                                eventId: `racing/simulcast_Click_AnyPage_Menu-ExpandTrackPicture`,
                                country: myContextState.selectedMeeting?.countryNameEn || '',
                                raceNo: generateAdobeDataRaceNo(myContextState.selectedMeetingDate, myContextState.selectedMeetingVenueCode, myContextState.selectedRaceNo.valueOf()),
                            });
                        }}>
                            <div>
                                <img src={myContextState.selectedRace?.trackMap?.src}></img>
                                {
                                    showTrackVideo() &&
                                    <p className='videoPayIcon'>
                                        <VideoPlayerIcon2 />
                                    </p> 
                                }
                                {
                                    isTrackImageOnly() &&
                                    <p className='fullscreenIcon'>
                                        <img src={`${myContextState.assetPrefix}/fullscreen_button.svg`} />
                                    </p>
                                }
                            </div>
                        </div> 
                    }
                    <div className='info'>
                        <div className='tit'>
                            <p>
                                {myContextState.selectedMeeting?.generateTabLabel()}
                                {
                                    //presite ? <></> :
                                        meetingInfo?.worldPoolPath &&
                                        <img
                                            src={`${meetingInfo?.worldPoolPath }`} />
                                } 
                            </p>
                            {
                                props?.type == "pc" ? RenderBottomBtn() :
                                    <div className={`rightIcon ${openRaceInfo && "expand"}`} onClick={() => { setOpenRaceInfo(!openRaceInfo) }}>
                                        <KeyboardArrowUpIcon />
                                    </div>
                            } 
                        </div>
                        <div
                            className={`b-info`}
                            style={{
                                display: openRaceInfo || props?.type == "pc" ? "block" : "none",
                            }}
                        >
                            {
                                myContextState.selectedRaceNo.valueOf() === -1 ?
                                <p>{meetingInfo?.racecourse}, {meetingInfo?.countryName}</p>
                                : <>
                                    {handleRaceInfo() && <p>{handleRaceInfo()}</p> }
                                    {
                                        (meetingInfo?.going && props?.type == "pc") && 
                                        <p>{meetingInfo?.going}</p>
                                    } 
                                    {
                                        (meetingInfo?.racecourse && meetingInfo?.countryName) && 
                                        <p>{(props?.type == "mobile" && meetingInfo?.going) ? meetingInfo?.going + ', ' : ''}{meetingInfo?.racecourse}, {meetingInfo?.countryName}</p>
                                    }  
                                </>
                            }
                        </div> 
                    </div> 
                </div>
                {
                    props?.type == "mobile" && RenderBottomBtn()
                }
                {   props?.type == "mobile" && isRaceCardPage() && myContextState.renderMobileRaceCardStatus && myContextState.renderMobileRaceCardStatus()}
                {PopoverPC()}
                {DialogMobile()}
                <VideoPlayer
                title={`${meetingInfo?.racecourse}, ${meetingInfo?.countryName}`}
                type={trackVideoType}
                trackImageSrc={myContextState.selectedRace?.trackMap?.src}
                WAData={WAData}
                sources={videoSources} open={isShowVideoPlay} isMobile={isMobile} handleClose={handleVideoClose} width={isMobile ? "calc(100% - 16px)" : '60%'} height={isMobile ? undefined : 'unset'} showCurrentTooltip showHoveredTooltip />

            </div>
        </>
    ) : (isLoadingRaceInfo ? racingInfoSkeleton(isMobile) : <NoInformation sx={{ borderRadius: "4px 4px" }} />)
};

export const racingInfoSkeleton = (isMobile: boolean, sx?: SxProps<Theme>) => <Skeleton variant="rounded" height={isMobile ? 150 : 100} sx={sx} />

export default RacingInfo;
